import * as PIXI from "pixi.js";
import {Sprite} from "../../Core/Sprite";
import {PuzzleModel} from "./PuzzleModel";
import {texture} from "../../Core/AssetHelpers";
import {HoverableButton, TextureButton} from "../../Core/Button";
import {Mix} from "../../Core/Reflection";
import {Draggable} from "../Draggable";
import {Signal} from "../../Core/Signal";
import {TransformBackup} from "../../Core/TransformBackup";
import {Focusable} from "../Focusable";
import {ColorOverlayFilter} from "../../Filters/ColorOverlayFilter";
import {Button} from "../Button";
import {Anchor} from "../../Core/Anchor";

export class PuzzlePiece extends Mix(TextureButton, HoverableButton(), Draggable, TransformBackup, Focusable) {

    public readonly onStartDrag = Signal<(e: PIXI.InteractionEvent) => void>();
    public readonly onStopDrag = Signal<(e: PIXI.InteractionEvent) => void>();
    public readonly onDrag = Signal<() => void>();

    public readonly background = this.visuals.addChild(new Sprite());
    public readonly foreground = this.visuals.addChild(new Sprite());
    public readonly index: number;
    public placeholder?: PuzzlePiecePlaceholder;

    public readonly downDisabled = true;
    private _keyboardSelected = false;

    private static selectedFilters = [new ColorOverlayFilter(0x000000, 0.4)];

    constructor(index: number) {
        super();

        this.index = index;
        this.anchor.x = 0;
        this.anchor.y = 0;
    }

    public setModel(model: PuzzleModel) {
        this.foreground.texture = texture(`puzzle-piece-${model.puzzleType}-${this.index}`) || this.foreground.texture;
    }

    onFocusActivated(): void {
        if (this.enabled && this.worldVisible) {
            this.keyboardSelected = true;
            this.onClick(this);
        }
    }

    get keyboardSelected(): boolean {
        return this._keyboardSelected;
    }

    set keyboardSelected(value: boolean) {
        if (this._keyboardSelected != value) {
            this._keyboardSelected = value;
            this.filters = value ? PuzzlePiece.selectedFilters : [];
        }
    }
}

export class PuzzlePiecePlaceholder extends Button {

    public readonly piece: PuzzlePiece;

    constructor(piece: PuzzlePiece) {
        super(undefined, undefined, Anchor.topLeft);

        this.x = piece.x;
        this.y = piece.y;
        this.width = piece.width;
        this.height = piece.height;
        this.clickSfx = undefined;

        this.piece = piece;
        piece.placeholder = this;
    }
}